/**
 * Property domain schemas, derived from the generated Zod. See ./README.md.
 *
 * There is no standalone address schema: the address is only ever read as
 * `PropertiesRetrieveResponse.shape.address`, and the API exposes no `/addresses`
 * endpoint to derive one from.
 *
 * `serviceProviders` is deliberately NOT on `propertySchema`. It is not on
 * `PropertySerializer` at all — it belongs to the portfolio read's nested
 * `PropertyClientGroup` (`PortfoliosListResponse`), which is what the two live
 * consumers (`routes/_app.tsx`, `lib/portfolio/getPortfolioTableColumns`)
 * already read it from. The old hand-written schema was a hybrid of the two
 * serializers.
 */
import { z } from 'zod';

import {
  PropertiesFormListResponse,
  PropertiesRetrieveResponse,
} from '~/data/generated/zod/properties/properties.zod';

/**
 * Property domain schema (partial), derived from the generated Zod. Scoped to
 * the "Otto example property name" read, which uses only `name`. No overrides:
 * the generated `.optional()` id is a write-path allowance, permissive rather
 * than the dangerous direction.
 */
export const propertyFormOptionSchema = PropertiesFormListResponse.element;

// `Contact.email` is `EmailField(blank=True, default="")` and
// `ContactSerializer.validate_email` coerces null to `""`, so a contact with no
// email is on the wire as an empty string — which the generated `.email()`
// rejects on read.
const propertyContactSchema = PropertiesRetrieveResponse.shape.contact
  .unwrap()
  .unwrap()
  .extend({
    email: z.union([z.literal(''), z.string().email()]).nullish(),
  });

export const propertySchema = PropertiesRetrieveResponse.extend({
  contact: propertyContactSchema.nullish(),
});
